import { redirect } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";

import {
  NO_MODALITY_CHOSEN,
  reservedScheduleFormAtom,
} from "@/lib/atoms/reserved-schedule-form-atom";

/**
 * Barra as telas seguintes do fluxo de criação quando a categoria ainda não foi escolhida.
 *
 * O rascunho é estado de cliente, então chegar em `/create/slots` ou `/create/confirm` por fora do
 * formulário — link direto, refresh, volta do histórico depois de o atom ser resetado — deixa a
 * categoria em `0`. Sem a guarda, a busca de horários sairia com
 * `codModalidadePeriodoGarantido: 0` e a simulação de preço também: o backend recusa, e o membro
 * leria "não há salas disponíveis" em vez do problema real.
 *
 * ## Por que no `loader` e não no render
 *
 * O `loader` roda **antes** de o componente montar, então a requisição inútil nunca sai — não
 * precisa de `enabled` na query nem de um `<Navigate>` no meio do JSX. E `<Navigate>` era pior do
 * que inelegante: nos testes de rota, que montam a página dentro de um router mínimo, ele **travava**
 * a suíte em vez de falhar.
 *
 * ## Por que ler o atom fora do React é seguro aqui
 *
 * O app não tem `Provider` do jotai, então `getDefaultStore()` é a mesma store que os componentes
 * usam. A leitura é única e não reativa — que é exatamente o que uma guarda precisa.
 */
export const requireChosenModality = (): void => {
  if (getDefaultStore().get(reservedScheduleFormAtom).modality === NO_MODALITY_CHOSEN) {
    redirect({ to: "/settings/reserved-schedules/create", throw: true });
  }
};
